/* Allurify product card behavior (wishlist + quick add).
   Moved out of snippets/card-product.liquid so it loads once per page instead of once per card. */
(() => {
  if (window.__allurifyExactGlobalCardsReady) return;
  window.__allurifyExactGlobalCardsReady = true;

  const KEY = 'customWishlist';

  const getWishlist = () => {
    try {
      const items = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(items) ? items : [];
    } catch (error) {
      return [];
    }
  };

  const saveWishlist = (items) => {
    localStorage.setItem(KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('custom:wishlist-updated', {
      detail: { items, count: items.length }
    }));
  };

  const syncWishlistButtons = () => {
    const list = getWishlist();
    const handles = new Set(list.map((item) => item.handle));

    document.querySelectorAll('[data-custom-collection-wishlist]').forEach((button) => {
      const active = handles.has(button.dataset.productHandle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    document.querySelectorAll('[data-custom-wishlist-count]').forEach((node) => {
      node.textContent = list.length > 9 ? '9+' : String(list.length);
      node.hidden = list.length < 1;
    });
  };

  document.addEventListener('click', async (event) => {
    const wishlistButton = event.target.closest('[data-custom-collection-wishlist]');

    if (wishlistButton) {
      event.preventDefault();
      event.stopPropagation();

      const product = {
        productId: wishlistButton.dataset.productId,
        variantId: wishlistButton.dataset.variantId,
        handle: wishlistButton.dataset.productHandle,
        url: wishlistButton.dataset.productUrl,
        title: wishlistButton.dataset.productTitle,
        vendor: wishlistButton.dataset.productVendor,
        image: wishlistButton.dataset.productImage,
        price: wishlistButton.dataset.productPrice,
        comparePrice: wishlistButton.dataset.productComparePrice
      };

      let list = getWishlist();
      const exists = list.some((item) => item.handle === product.handle);

      list = exists
        ? list.filter((item) => item.handle !== product.handle)
        : [product, ...list.filter((item) => item.handle !== product.handle)];

      saveWishlist(list);
      syncWishlistButtons();
      return;
    }

    const cartButton = event.target.closest('[data-add-variant]');
    if (!cartButton) return;
    if (cartButton.disabled || cartButton.classList.contains('is-loading')) return;

    event.preventDefault();
    event.stopPropagation();

    cartButton.classList.add('is-loading');

    const cartUi =
      document.querySelector('cart-drawer') ||
      document.querySelector('cart-notification');

    try {
      const formData = new FormData();
      formData.append('id', cartButton.dataset.addVariant);
      formData.append('quantity', '1');

      if (cartUi && typeof cartUi.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cartUi.getSectionsToRender().map((item) => item.id).join(',')
        );
        formData.append('sections_url', window.location.pathname);
      }

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      const data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Unable to add item');
      }

      cartButton.classList.add('is-added');

      if (cartUi && typeof cartUi.renderContents === 'function' && data.sections) {
        cartUi.renderContents(data);
      } else {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, {
          headers: { Accept: 'application/json' }
        });
        const cart = await cartResponse.json();

        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach((node) => {
          node.textContent = cart.item_count;
        });

        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      }

      setTimeout(() => cartButton.classList.remove('is-added'), 1400);
    } catch (error) {
      console.error('Allurify global card add to cart error:', error);
      cartButton.classList.add('has-error');
      setTimeout(() => cartButton.classList.remove('has-error'), 1800);
    } finally {
      cartButton.classList.remove('is-loading');
    }
  });

  window.addEventListener('storage', syncWishlistButtons);
  document.addEventListener('custom:wishlist-updated', syncWishlistButtons);
  document.addEventListener('shopify:section:load', syncWishlistButtons);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncWishlistButtons, { once: true });
  } else {
    syncWishlistButtons();
  }
})();
